import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import NavbarHeader from './NavbarHeader'

export default function Layout() {
    const location = useLocation()
    return (
        <div>
            {
                (location.pathname && !location.pathname.includes("questionnaire") && !location.pathname.includes("reward")) && <NavbarHeader />
            }
            <Outlet />
        </div>
    )
}
